import { Sparkles } from "lucide-react";
import { Typography } from "@/components/common/ui/Typography";

export interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

export function Loading({
  message = "Loading...",
  fullScreen = true,
}: LoadingProps) {
  const containerClasses = fullScreen
    ? "fixed inset-0 [body[data-environment-banner]_&]:top-7 z-50 flex items-center justify-center bg-white"
    : "flex items-center justify-center min-h-[calc(100vh-12rem)]";

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center gap-6">
        {/* Simple elegant spinner */}
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full" />
          <div className="absolute inset-0 border-4 border-navigator-primary border-t-transparent rounded-full animate-spin" />
        </div>

        {/* Clean text */}
        <div className="text-center space-y-2">
          <Typography variant="headline4">{message}</Typography>
          <Typography variant="body" color="light">Please wait</Typography>
        </div>
      </div>
    </div>
  );
}
